/*
  !Important
  IFrame component use iframe-resizer 3rd party lib version 4.3.2 which is outdated.
  This version is used intentionally, because newer version require licence key.
 */

import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { useEffect, useMemo, useRef, useState } from 'react';
import iframeResize from 'iframe-resizer/js/iframeResizer.min';
import styles from './IFrame.module.scss';

const SCROLL_EXCEPTIONS = [/lt.morningstar/, /vds.issgovernance/, /www.brighttalk/];
interface IFrameFields {
  source: {
    value: string;
  };
}

interface IFrameProps extends ComponentProps {
  fields: IFrameFields;
}
const IFrame = ({ fields, rendering }: IFrameProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isClient, setIsClient] = useState(false);

  const shouldScroll: string = SCROLL_EXCEPTIONS.some((url) => url.test(fields.source.value))
    ? 'yes'
    : 'no';

  const src = useMemo(() => {
    if (typeof window !== 'undefined' && rendering.params?.passUrlParameters === '1') {
      const url = new URL(fields.source.value);
      const parentUrl = new URL(location.href);

      parentUrl.searchParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });

      return url.href;
    }

    return fields.source.value;
  }, [fields.source.value, rendering.params]);

  useEffect(() => {
    setIsClient(true);
    if (shouldScroll === 'no') {
      iframeResize({}, iframeRef.current);
    }
  }, []);

  return (
    <div id={anchorId} data-e2e-component-uid={rendering.uid} className={`w-100 ${styles.iframe}`}>
      {sitecoreContext.pageEditing ? styles['experience-editor-holder'] : ''}
      {isClient && (
        <iframe
          ref={iframeRef}
          aria-label="iframe"
          title="Iframe"
          src={src}
          key={src}
          style={shouldScroll === 'no' ? { overflow: 'hidden' } : { overflow: 'scroll' }}
          className="w-100"
        />
      )}
    </div>
  );
};

export default IFrame;
